var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',{staticClass:"mt-8",attrs:{"align":"center","justify":"center"}},[_c('VCol',{staticClass:"text-center",attrs:{"cols":"12","md":"2"}},[_c('VImg',{staticClass:"mx-auto",attrs:{"src":require('@/assets/wedding-rings-bronze.svg'),"contain":"","eager":"","width":"120px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }